import styled from "styled-components";
import { useState, useEffect } from "react";

import { Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import SelectRole from "./login user components/SelectRole";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export default function Welcome() {
  const axios = useAxios();
  const { loader } = useComponent();

  const [brands, setBrands] = useState([]);

  const userID = sessionStorage.getItem("userID");
  const authToken = sessionStorage.getItem("authToken");
  const businessEntityID = sessionStorage.getItem("businessEntityId");

  useEffect(() => {
    loader.start(1);
    axios({
      url: "/brand?businessEntityId=" + businessEntityID,
    }).then((response) => {
      if (response.status) {
        let brandList = [];
        for (const brand of response?.data?.parsedBrands) {
          if (brand?.is_visible) {
            brandList.push({
              ID: brand.brand_id,
              about: brand.about,
              brandName: brand.brand_name,
              logo: !!brand.logo
                ? brand.logo
                : "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/NaN_logo.png",
              languages: brand.languages,
              locations: brand.audience_location,
              category: brand.site_category,
              mau: brand.mau,
              onlineStore: brand.online_store,
              website: brand.website,
              socialMedia: brand.social_media_handles,
              brandType: brand.brand_type_id,
              isBrandVerified: brand.is_brand_verified,
              isVisible: brand.is_visible,
            });
          }
        }

        brandList.slice().sort((a, b) => {
          if (a.brandName.toLowerCase() === b.brandName.toLowerCase()) {
            return a.brandName > b.brandName ? 1 : -1;
          }
          return a.brandName > b.brandName ? 1 : -1;
        });
        setBrands(brandList);
        loader.apiComplete();
      }
    });
  }, [axios, businessEntityID, loader]);

  return (
    <Wrapper>
      <div className="wrapper-container"></div>

      <Loader height={"75%"}>
        <SelectRole
          brands={brands}
          authToken={authToken}
          businessEntityID={businessEntityID}
          userID={userID}
        />
      </Loader>
    </Wrapper>
  );
}
